import { notify } from 'notif';

export async function promiseMapAll(promiseMap) {
    try {
        const promises = await Promise.all(Object.values(promiseMap));
        let objMapped = {};
        Object.keys(promiseMap).forEach((key, i) => {
            objMapped[key] = promises[i];
        });
        return objMapped;
    } catch (err) {
        return { err };
    }
}

export function multiPrompt(obj) {
    const ret = {};
    for (const k in obj) {
        let val = prompt(obj[k]);
        if (!val) return;
        ret[k] = val;
    }
    return ret;
}

export function getError(e) {
    if (e && e.error) {
        return e.error;
    } else if (typeof e === 'string' || e instanceof String) {
        return e;
    }
}

export function error(e) {
    console.error(e);
    const message = getError(e) || 'error';
    alert(message);
    notify.error({ message });
}

export function success(msg) {
    const message = msg || 'ok';
    notify.success({ message });
}

export function gotoJob(history, job) {
    history.push('/' + job.url);
}

export async function retry(fn, n = 3) {
    try {
        return await fn();
    } catch (e) {
        if (n > 0) {
            return await retry(fn, n - 1);
        } else {
            throw e;
        }
    }
}

export function getSentryErrorLevel(errorCode) {
    return /^5[0-9][0-9]$/.test(errorCode) ? 'fatal' : 'error';
}

export function  getTransformationUrl(imageKey, size=400) {
    return `https://z.nooncdn.com/tr:n-t_${size}/${imageKey || 'default'}.jpg`;
}



// WEBPACK FOOTER //
// ./src/utils/helper.js